window.addEventListener("load", () => {

    let sliders = document.querySelectorAll('.swiper');

    if (sliders) {
        sliders.forEach((slider) => {
            sliderSetup(slider);
            cursorSliderData(slider);
        })
    }

    function sliderSetup(slider) {
        let cursor = slider.getAttribute('cursor');
        let autoplayDelay = slider.getAttribute('autoplay-delay');
        let loop = slider.getAttribute('loop');
        let clickable = slider.getAttribute('clickable');
        let draggable = slider.getAttribute('draggable');
        let keyboard = slider.getAttribute('keyboard');
        let effect = slider.getAttribute('effect');
        let places = slider.getAttribute('places');
        let images = slider.querySelectorAll('.swiper-slide img');

       
        if (loop === "true") {
            loop == true;
        } else {
            loop == false;
        }
        if (draggable === "true") {
            draggable == true;
        } else {
            draggable == false;
        }
        if (keyboard === "true") {
            keyboard == true;
        } else {
            keyboard == false;
        }

        const hasNavigation = slider.classList.contains('swiper-navigation')
        console.log(slider, hasNavigation)
        if(slider.classList.contains('swiper-main')) {

            if (autoplayDelay) {
                var swiper = new Swiper(slider, {
                    slidesPerView: 1,
                    loop: loop,
                    allowTouchMove: draggable,
                    keyboard: {
                        enabled: keyboard,
                    },
                    autoplay: {
                        delay: autoplayDelay,
                        stopOnLastSlide: true,
                    },
                    speed:700,
                    effect: effect,
                    navigation: hasNavigation ? {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    } : false,
                });
                
            } else {
                var swiper = new Swiper(slider, {
                    slidesPerView: 1,
                    loop: loop,
                    allowTouchMove: draggable,
                    keyboard: {
                        enabled: keyboard,
                    },
                    autoplay: false,
                    speed:700,
                    effect: effect,
                    navigation: hasNavigation ? {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    } : false,
                });
            }
        }

        if(clickable === "true") {
            sliderClickable(slider, swiper);
        }
        if(cursor === "true") {
            cursorSliderPosition(slider);
        }
        if(places === "true") {
            placesSlider(swiper);
        }

        if(images) {
            handleImages(images);
        }
        console.log(swiper)

        //if(slider.classList.contains('swiper-preview-apartments')){
        //    console.log(swiper)
        //    swiper.params.navigation = {
        //        nextEl: '.swiper-button-next',
        //        prevEl: '.swiper-button-prev',
        //      };
        //    swiper.navigation.init()
        //    swiper.navigation.update()
        //}

        let swiperThumbs = document.querySelector('.swiper-thumbs');
        if(swiperThumbs) {
            swiperThumbsSetup(slider, swiper, swiperThumbs);
        }
        swiper.on('slideChange', function () {
            cursorSliderData(slider);
        });
        
    }

    function cursorSliderPosition(slider) {

        let showAllSlidesBtn = slider.querySelector('#show-all-slides');
        const cursor = slider.querySelector('#cursor');
        const leftArrow = slider.querySelector('#left-arrow');
        const rightArrow = slider.querySelector('#right-arrow');
        const sliderWidth = slider.offsetWidth;
        const sliderWidthHalf = sliderWidth / 2;
        
        if(!slider.classList.contains('swiper-thumbs')) {
            slider.addEventListener('mousemove', (e) => {
                if(cursor) {

                    cursor.style.left = e.clientX + 'px';
                    cursor.style.top = e.clientY + 'px';

                    if(e.target.getAttribute('id') === "show-all-slides") {

                        cursor.classList.remove('active');
                    } else {
                        cursor.classList.add('active');
                    }
        
                    if(e.offsetX <= sliderWidthHalf) {
                        leftArrow.style.display = "block";
                        rightArrow.style.display = "none";
                    } else {
                        rightArrow.style.display = "block";
                        leftArrow.style.display = "none";
                    }
                    slider.addEventListener('mouseover', () => {
                        cursor.classList.add('active');
                    });
                    slider.addEventListener('mouseout', () => {
                        cursor.classList.remove('active');
                    });
                }
            });
            
                
        }

        if(showAllSlidesBtn) {
            showAllSlidesBtn.addEventListener('mousemove', () => {
                cursor.classList.remove('active');
            });
        }
    }

    function cursorSliderData(slider) {
        var sliderMainTitle = slider.querySelector('#slider-main-title');
        var slideRealIndex= slider.swiper.realIndex;
        var slideActiveIndex= slider.swiper.activeIndex;
        var slideActiveIndexDisplayed= slideRealIndex + 1;
        var totalSlidesCount = slider.swiper.slides.length
        var slides = slider.swiper.slides
        var slideActive = slides[slideActiveIndex];
        var slideActiveTitle = slideActive.dataset.title;
        var cursor = slider.querySelector('#cursor');

        if(cursor) {
            var imageTitle = cursor.querySelector('#image-title');
            var counter = cursor.querySelector('#counter');
            if(imageTitle) {
                imageTitle.innerHTML = slideActiveTitle;
            }
            if(counter) {
                var currentIndex = counter.querySelector('#current-slide');
                var totalSlides = counter.querySelector('#total-slides');
                currentIndex.textContent = slideActiveIndexDisplayed;
                totalSlides.innerHTML = totalSlidesCount;
            }
        }
        
        if(sliderMainTitle) {
            sliderMainTitle.textContent = slideActiveTitle;
        }
        

    }

    function sliderClickable(slider, swiper) {

        let placesSlider = slider.getAttribute('places');

        const sliderWidth = slider.offsetWidth;
        const sliderWidthHalf = sliderWidth / 2;

        if(!slider.classList.contains('swiper-thumbs')) {

            // CLICK 
            slider.addEventListener('click', (e) => {
                if(!e.target.id) {
                    if(e.offsetX <= sliderWidthHalf) {
                        swiper.slidePrev();
                    } else {
                        swiper.slideNext();
                    }
                    cursorSliderData(slider);
                    
                }
            });
            swiper.on('slideChange', function () {
                if(placesSlider) {
                    placesSlideTo(swiper);
                }
            });

           
        }
    }

    function swiperThumbsSetup(slider, swiper, swiperThumbs) {

        let button = slider.querySelector('#show-all-slides');
        let body = document.querySelector('body');

        if(button && swiperThumbs) {

            let images = swiperThumbs.querySelectorAll('.swiper-slide img');
            let closeIcon = swiperThumbs.querySelector('#close-swiper-thumbs');

            button.style.display = "block";
            button.addEventListener('click' , function() {
                swiperThumbs.classList.add('open');
                //body.classList.add('no-scroll');

            })
            closeIcon.addEventListener('click' , function() {
                swiperThumbs.classList.remove('open');
                body.classList.remove('no-scroll');
            })

            images.forEach(function(image) {
                image.addEventListener('click' , function() {
                    let index = image.getAttribute('data-index');
                    swiperThumbs.classList.remove('open');
                    body.classList.remove('no-scroll');
                    swiper.slideTo(index);
                    cursorSliderData(slider);
                })
            })
        }

    

    }

    function placesSlider(swiper) {
   
        let placesSlider = document.querySelector('.hamlet-townhouse .places-slider');
        if(placesSlider) {
            let places = placesSlider.querySelectorAll('li');
            places.forEach(function(place) {
                place.addEventListener('click' , function() {
                    placeSlideTo(place);
                    swiperSlideTo(swiper , place);
                })
            })
        }
    }
    
    function placesSlideTo(swiper) {
        let placesSlider = document.querySelector('.hamlet-townhouse .places-slider');
        let realIndex = swiper.realIndex;
        let places = placesSlider.querySelectorAll('li');
        let targetPlace = places[realIndex];
        placeSlideTo(targetPlace , realIndex);
                
    }
    
    function placeSlideTo(place , realIndex) {
        
        resetPlaces();

        let placeContent;
        let placeIndex = place.getAttribute('place-index');

        if(realIndex) {
            placeContent = document.querySelector(`[content-index="${realIndex}"]`);
        } else {
            placeContent = document.querySelector(`[content-index="${placeIndex}"]`);
        }
        place.classList.add('open');
        placeContent.classList.add('open');
    }

    function resetPlaces() {
        let places = document.querySelectorAll('.places-titles li');
        let placesContent = document.querySelectorAll('.places-content p');
        places.forEach(function(place) {
            place.classList.remove('open');
        })
        placesContent.forEach(function(placeContent) {
            placeContent.classList.remove('open');

        })
    }

    function swiperSlideTo(swiper , place) {
        let placeIndex = place.getAttribute('place-index');
        swiper.slideTo(placeIndex);
    }
    
    function handleImages(images) {
        if(images) {
            images.forEach(function(img) {
                let imgHeight = img.naturalHeight;
                let imgWidth = img.naturalWidth;

                if(imgHeight > imgWidth) {
                    img.classList.add('vertical');
                } else {
                    img.classList.add('horizontal');
                }
            })  
        }
    }
});

